import React, {useEffect} from "react";
import PropTypes from "prop-types";
import { confirmable } from "react-confirm";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputContainer from "../../../forms/hookfields/InputContainer";

const schema = yup.object().shape({
    reason: yup
        .string()
        .required(),
    source: yup
        .string()
        .required()
});

const BlacklistModal = ({
  show,
  proceed,
  dismiss,
  cancel,
  confirmation,
  options
}) => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      reason: '',
      source: ''
    },
    resolver: yupResolver(schema)
  });

  const mode = options?.mode || 'blacklist';
  const title = mode === 'blacklist' ? 'Blacklist' : 'Unblacklist';
  const buttonText = mode === 'blacklist' ? 'Blacklist' : 'Unblacklist';

  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [show]);

  const _handleSubmit = values => {
    proceed({
      values
    });
  };

  return (
    <>
      <div
        key="modal"
        className={"modal fade " + (show ? "show" : "")}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {title}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={dismiss}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form
              className="m-login__form m-form"
              onSubmit={handleSubmit(_handleSubmit)}
            >
              <div className="modal-body">
                <InputContainer
                  errors={errors}
                  label={"Reason"}
                  required={true}
                  name={"reason"}
                >
                  <textarea
                    className="form-control m-input"
                    name="reason"
                    id="reason"
                    {...register("reason")}
                  />
                </InputContainer>

                <InputContainer
                  errors={errors}
                  label={"Source"}
                  required={true}
                  name={"source"}
                >
                  <input
                    type={"text"}
                    className="form-control m-input"
                    name="source"
                    id="source"
                    {...register("source")}
                  />
                </InputContainer>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={cancel}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={"btn btn-danger"}
                >
                  {buttonText}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className={"modal-backdrop fade " + (show ? "show" : "")}
      />
    </>
  );
}

BlacklistModal.propTypes = {
    show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
    proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
    cancel: PropTypes.func, // from confirmable. call to close the dialog with promise rejected.
    dismiss: PropTypes.func, // from confirmable. call to only close the dialog.
    confirmation: PropTypes.string, // arguments of your confirm function
    options: PropTypes.object // arguments of your confirm function
};

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
export default confirmable(BlacklistModal);
